import {configInvoiceApi} from "../../../api/category/configInvoiceApi";
import {IAccConfigInvoice} from "../../../model/respone/category/IAccConfigInvoice";
import {IBaseRespone} from "../../../model/respone/IBaseRespone";
import {
    eAccConfigInvoiceActionIds,
    IAccConfigInvoiceActionTypes,
} from "../../action-types/category/IAccConfigInvoiceActions";
import {rootActions} from "../../actions/rootActions";
import {call, put, takeEvery, takeLatest} from "redux-saga/effects";

export function* configInvoiceSaga(): any {
    yield takeLatest(eAccConfigInvoiceActionIds.LOAD_START, loadWorker);
    yield takeEvery(eAccConfigInvoiceActionIds.SAVE_START, saveWorker);
    yield takeEvery(eAccConfigInvoiceActionIds.DELETE_START, deleteWorker);
    yield takeEvery(
        eAccConfigInvoiceActionIds.DELETE_MANY_START,
        deleteManyWorker
    );
}

function* loadWorker(): any {
    const res: IBaseRespone = yield call(configInvoiceApi.SelectAll);
    if (res.is_success) {
        yield put(rootActions.category.configInvoice.LOAD_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.category.configInvoice.LOAD_ERRR(res.message ?? "Có lỗi")
        );
    }
}

function* saveWorker(action: IAccConfigInvoiceActionTypes): any {
    let res: IBaseRespone;
    const payload = action.payload as IAccConfigInvoice;
    if (payload.id > 0) {
        res = yield call(configInvoiceApi.Update, payload);
    } else {
        res = yield call(configInvoiceApi.Insert, payload);
    }
    if (res) {
        if (res.is_success) {
            yield put(rootActions.category.configInvoice.SAVE_SUCCESS(res.data));
        } else {
            yield put(
                rootActions.category.configInvoice.SAVE_ERROR(res.message ?? "Có lỗi")
            );
        }
    }
}

function* deleteWorker(action: IAccConfigInvoiceActionTypes): any {
    const res: IBaseRespone = yield call(
        configInvoiceApi.Delete,
        action.payload as number
    );
    if (res.is_success) {
        yield put(rootActions.category.configInvoice.DELETE_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.category.configInvoice.DELETE_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* deleteManyWorker(action: IAccConfigInvoiceActionTypes): any {
    const res: number = yield call(
        configInvoiceApi.DeleteMany,
        action.payload as number[]
    );
    if (res > 0) {
        yield put(
            rootActions.category.configInvoice.DELETE_MANY_SUCCESS(undefined)
        );
    } else {
        yield put(rootActions.category.configInvoice.DELETE_MANY_ERROR("Có lỗi"));
    }
}
